import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

import { Button } from 'react-bootstrap';

// Components
import UserList from './UserList';
import AddUserModal from './AddModal';
import TimeModal from './TimeModal';

const UserScreen = (props) => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [showTimeModal, setShowTimeModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [updateCount, setUpdateCount] = useState(0); // This will refresh the screen

    useEffect(() => {
        loadUsers();
    }, [updateCount])

    const loadUsers = async () => {
        const url = process.env.REACT_APP_API_URL;
        const authToken = sessionStorage.getItem('auth-token');

        const request = await fetch(`${url}/users`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            });

        if (request.status === 200) {
            const fetchUsers = await request.json();
            setUsers(fetchUsers);
        }
    };

    const viewUserClocks = (userId) => {
        setShowTimeModal(true);
        setSelectedUser(userId);
    }

    return (
        <section className={styles.UserScreen}>
            <AddUserModal show={showAddModal} setShow={setShowAddModal} loadUsersHandler={loadUsers} />
            <TimeModal 
                show={showTimeModal} 
                userId={selectedUser}
                closeModal={() => setShowTimeModal(false)} />
            <div className={styles.UserHeading}>
                <h4 className={styles.Title}>Usuarios</h4>
                <div className={styles.Actions}>
                    <Button size="sm" onClick={() => setShowAddModal(true)}>
                        <FontAwesomeIcon icon={faUserPlus} className={styles.Icon} />
                        <span>Nuevo Usuario</span>
                    </Button>
                </div>
            </div>
            <UserList users={users} setUpdateCount={setUpdateCount} viewUserClocks={viewUserClocks}  />
        </section>
    );
}

export default UserScreen;